export class Department {
    ID: number;
    ORG_ID: number
    CLIENT_ID: number;
    NAME: string;
    SHORT_CODE: string;
    STATUS: boolean = true;
    SEQUENCE_NO: any;
    TICKET_TIME_PERIOD: number;
}